import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { IIconType } from "@/icons";
import { Icon, StyledIconWrapper } from "@/components/Icon";

interface IUseCaseHeaderSectionItem {
  title: string;
  text: string;
  icon: IIconType;
}

type IUseCaseHeaderSectionItemProps = IUseCaseHeaderSectionItem &
  JSX.IntrinsicElements["div"];

export const UseCaseHeaderSectionItem: React.FC<IUseCaseHeaderSectionItemProps> = ({
  title,
  text,
  icon,
}) => {
  const { css } = useFela();
  const { bp, colors } = useTheme();

  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexBasis: "33%",
        nested: {
          ":not(:last-child)": {
            marginBottom: 20,
            [bp.FROM_TABLET]: {
              marginBottom: 0,
            },
          },
        },
        [bp.FROM_TABLET]: {
          maxWidth: 312,
          nested: {
            ":not(:last-child)": {
              marginRight: 50,
            },
          },
        },
      })}
    >
      <StyledIconWrapper wrapperStyle={{ height: 40, marginBottom: 30 }}>
        <Icon iconType={icon} />
      </StyledIconWrapper>
      <Heading as="h3" customStyle={{ marginBottom: 8, textAlign: "center" }}>
        {title}
      </Heading>
      <p className={css({ textAlign: "center", color: colors.GRAY })}>{text}</p>
    </div>
  );
};
